import { createContext } from "react";

import { RootStore } from "@stores/root/RootStore.ts";

export const StoresContext = createContext<RootStore>({} as RootStore);
